// @ts-nocheck

import React, { useContext, useLayoutEffect, useState } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  Button,
  useDisclosure,
  Textarea,
  Tooltip,
  useToast,
} from '@chakra-ui/react';
import { MdInfoOutline } from 'react-icons/md';
import { useTranslation } from 'react-i18next';

import LoadContext from 'hooks/useLoad';
import CustomTagContext from 'hooks/useCustomTag';
import { color } from 'styles/colors';
import ToolTip from 'components/ToolTip';
import InputSelect from 'components/InputSelect';
import SwitchToggle from 'components/SwitchToggleGeneral';
import InputNumber from 'components/InputNumber';
import SelectInputImg from 'components/SelectInputImg';
import { CustomTagProps } from 'types/CustomTagProps';
import InputSelectWithReqCustomTag from 'components/InputSelectWithReqCustomTag';
import { showToast } from 'utils/showToast';
import { getTags } from 'modules/CustomTag/reqs';
import { ImgRespProps } from 'types/ImgRespProps';
import { saveTag, editTag } from './reqs';
import { position } from './lists';
import * as S from './styles';

const initialDataForm: CustomTagProps = {
  id: '',
  text: '',
  vtex_cluster_id: '',
  vtex_cluster_name: '',
  priority: 1,
  color: '#ffffff',
  font_size: null,
  location: null,
  background_color: '#000',
  position: 'bottom-right',
  visible: false,
  file_id: null,
  created_at: '',
  updated_at: '',
  file: null,
};

export default function FormCustomTag() {
  const {
    isFormOpen,
    setIsFormOpen,
    setIsEdit,
    setItemToEdit,
    isEdit,
    setTags,
    itemToEdit,
    setPagesData,
    isReq,
    pagesData,
  } = useContext(CustomTagContext);
  const { t } = useTranslation();
  const toast = useToast();
  const { setIsLoad } = useContext(LoadContext);

  const [dataForm, setDataForm] = useState<CustomTagProps>(initialDataForm);
  console.log('dataForm: ', dataForm);

  function onClose() {
    setIsFormOpen(false);
  }

  async function onSave() {
    if (dataForm.vtex_cluster_name === '') {
      showToast(
        toast,
        'customTags.warning',
        'customTags.warningCollectionMessage',
        'error',
        t,
      );
      return;
    }
    if (
      dataForm.text === '' &&
      (dataForm.file_id === '' || dataForm.file_id === null)
    ) {
      showToast(
        toast,
        'customTags.warning',
        'customTags.warningCollectionAndIconEmptyMessage',
        'error',
        t,
        5000,
      );
      return;
    }
    setIsLoad(true);
    const isSuccess = isEdit
      ? await editTag(dataForm, dataForm.id, toast, t)
      : await saveTag(dataForm, toast, t);
    setIsLoad(false);

    if (isSuccess) {
      await getTags(setTags, setPagesData, pagesData.page);
    }

    setIsFormOpen(false);
  }

  function resetFormWhenClose() {
    setIsEdit(false);
    setItemToEdit(null);
  }

  useLayoutEffect(() => {
    if (isEdit && itemToEdit !== null) {
      setDataForm(itemToEdit);
    }

    return () => {
      resetFormWhenClose();
    };
  }, []);

  return (
    <Modal size="5xl" isOpen={isFormOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('customTags.title')}</ModalHeader>

        <ModalCloseButton />

        <ModalBody>
          <S.container>
            <S.boxInput>
              <div>
                <p>{t('customTags.content')}</p>
                <ToolTip text={t('customTags.contentDescribe')} />
              </div>
              <Textarea
                disabled={dataForm?.file}
                placeholder={t('customTags.describe')}
                value={dataForm.text}
                onChange={value => {
                  setDataForm(obj => ({ ...obj, text: value.target.value }));
                }}
              />
            </S.boxInput>

            <S.treeInputs>
              <S.boxInput>
                <div>
                  <p>
                    {t('customTags.collection')} <b>*</b>
                  </p>
                  <ToolTip text={t('customTags.collectionDescribe')} />
                </div>
                <InputSelectWithReqCustomTag
                  placeholder={t('customTags.collectionName')}
                  initialValue={dataForm.vtex_cluster_name}
                  getVtexName={value => {
                    setDataForm(obj => ({ ...obj, vtex_cluster_name: value }));
                  }}
                  getVtexId={value => {
                    setDataForm(obj => ({ ...obj, vtex_cluster_id: value }));
                  }}
                />
              </S.boxInput>

              <S.boxInput>
                <div>
                  <p>{t('customTags.position')}</p>
                  <ToolTip text={t('customTags.positionDescribe')} />
                </div>
                <InputSelect
                  listOptions={position}
                  initialValue={dataForm.position}
                  getValue={value => {
                    setDataForm(obj => ({ ...obj, position: value }));
                  }}
                />
              </S.boxInput>

              <S.boxInput>
                <div>
                  <p>{t('customTags.activeTag')}</p>
                  <ToolTip text={t('customTags.activeTagDescribe')} />
                </div>

                <SwitchToggle
                  isChecked={dataForm.visible}
                  setIsChecked={() => {
                    setDataForm(obj => ({ ...obj, visible: !obj.visible }));
                  }}
                />
              </S.boxInput>
            </S.treeInputs>

            <S.treeInputs>
              <S.boxInput>
                <div>
                  <p>{t('customTags.priority')}</p>
                  <ToolTip text={t('customTags.priorityDescribe')} />
                </div>
                <InputNumber
                  max={5}
                  min={1}
                  step={1}
                  getValue={(value: string) => {
                    /* eslint-disable radix */
                    setDataForm(obj => ({
                      ...obj,
                      priority: parseInt(value),
                    }));
                    /* eslint-enable radix */
                  }}
                  value={dataForm.priority}
                />
              </S.boxInput>

              <S.boxInput>
                <div>
                  <p>{t('customTags.colorText')}</p>
                  <ToolTip text={t('customTags.colorTextDescribe')} />
                </div>
                <input
                  type="color"
                  value={dataForm.color}
                  onChange={value => {
                    setDataForm(obj => ({ ...obj, color: value.target.value }));
                  }}
                />
              </S.boxInput>

              <S.boxInput>
                <div>
                  <p>{t('customTags.backgroundColor')}</p>
                  <ToolTip text={t('customTags.backgroundColorDescribe')} />
                </div>
                <input
                  type="color"
                  value={dataForm.background_color}
                  onChange={value => {
                    setDataForm(obj => ({
                      ...obj,
                      background_color: value.target.value,
                    }));
                  }}
                />
              </S.boxInput>
            </S.treeInputs>

            <S.boxInput>
              <div>
                <p>{t('customTags.icon')}</p>
                <ToolTip text={t('customTags.iconDescribe')} />
              </div>
              <SelectInputImg
                isActive={dataForm.text === ''}
                initialImage={
                  itemToEdit && dataForm?.file ? dataForm.file.url : null
                }
                getImg={(img: ImgRespProps) => {
                  setDataForm(obj => ({
                    ...obj,
                    file_id: img?.id || null,
                    file: img || null,
                  }));
                }}
              />
            </S.boxInput>
          </S.container>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={onClose}>
            {t('close')}
          </Button>

          <Button
            color={color.interface.white}
            backgroundColor={color.system.success}
            variant="solid"
            onClick={onSave}
          >
            {t('save')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
